import { useEffect, useState } from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { fetchOpenApiDocument } from '../../../lib/apiClient';
import { swaggerA11yPlugin } from './swaggerA11yPlugin';
import './rest.css';

export const Route = createFileRoute('/settings/api-docs/rest')({
  component: SwaggerDocsPage,
});

export { SwaggerDocsPage };

function SwaggerDocsPage(): JSX.Element {
  const [spec, setSpec] = useState<Record<string, unknown> | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    fetchOpenApiDocument()
      .then((doc) => {
        if (active) setSpec(doc);
      })
      .catch((err: unknown) => {
        if (active) setError(err instanceof Error ? err.message : 'Failed to load API spec');
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="swagger-docs-page">
      <header className="swagger-docs-header">
        <Link to="/settings/api-docs" className="swagger-docs-back">
          <forge-icon name="arrow_back" aria-hidden="true"></forge-icon>
          API Documentation
        </Link>
        <p className="forge-typography--body2">
          The ingestion endpoint requires the <code>ingestion.write</code> scope. Click{' '}
          <strong>Authorize</strong> and paste an API Key (<code>ea_…</code>) to use &quot;Try it
          out&quot;.
        </p>
      </header>

      {error && (
        <p className="swagger-docs-error" role="alert">
          Failed to load the API specification: {error}
        </p>
      )}

      {!error && !spec && (
        <p className="swagger-docs-loading" aria-busy="true">
          Loading API specification…
        </p>
      )}

      {spec && <SwaggerUI spec={spec} plugins={[swaggerA11yPlugin]} />}
    </div>
  );
}
